import http from './http';

export default {
  getJackpots({
    wheelAccountId,
    dateFrom,
    dateTo,
    page,
    pageSize,
    search,
    sortBy,
    sortOrder,
    timezoneOffset,
  }) {
    return http.get(`/jackpot/winnings/${wheelAccountId}`, {
      params: {
        dateFrom,
        dateTo,
        page,
        pageSize,
        search,
        sortBy,
        sortOrder,
        timezoneOffset,
      },
    }).then((response) => {
      const result = response.data;
      return result;
    });
  },
};
